const SORTS = {
  'vehicles[sort]': (x) => x,
  'vehicles[zero_km]': (x) => x,
};

export default SORTS;
